/*
https://splidejs.com/guides/getting-started/
*/

import "@splidejs/splide/css/core";
import Splide from "@splidejs/splide";

const slider = document.querySelector(".patient-reviews-slider__slider");

if (slider) {
  var splide = new Splide(".patient-reviews-slider__slider", {
    type: "slider",
    rewind: true,
    speed: 1000,
    pagination: false,
    perPage: 1,
    perMove: 1,
  });

  splide.on("mounted", function () {
    var slideCount = splide.Components.Elements.slides.length;
    if (slideCount > 1) {
      splide.options = {
        arrows: false,
      };
    } else {
      splide.options = {
        arrows: false,
      };
    }

    splide.refresh();
  });

  splide.mount();
}